import HttpClientToken from '../../services/HttpClientToken';

import { defaultSentidoAmparo, SentidoAmparoProps } from '../../interfaces/catalogos/SentidoAmparoInterface';

export const SentidoAmparo = () => {

    return new Promise<SentidoAmparoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/SentidoAmparo/', token)
            .then( ({ data } : { data : SentidoAmparoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerSentidoAmparo = () => {

    return new Promise<SentidoAmparoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/SentidoAmparo/ObtenerSentidoAmparo', token)
            .then( ({ data } : { data : SentidoAmparoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarSentidoAmparo = ( params: SentidoAmparoProps ) => {

    return new Promise<SentidoAmparoProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/SentidoAmparo/Actualizar', params, token)
            .then( ({ data } : { data : SentidoAmparoProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultSentidoAmparo } );
            });

        }

    });

}

export const AgregarSentidoAmparo = ( params: SentidoAmparoProps ) => {

    return new Promise<SentidoAmparoProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/SentidoAmparo/Agregar', params, token)
            .then( ({ data } : { data : SentidoAmparoProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultSentidoAmparo } );
            });

        }

    });

}
